var map = {
	"./comgate.png": 740,
	"./gopay.svg": 741,
	"./gpwebpay.png": 742,
	"./maestro.svg": 743,
	"./master-card-electronic.svg": 744,
	"./master-card-secure-code.svg": 745,
	"./master-card.svg": 746,
	"./verified-by-visa.svg": 747,
	"./visa-electron.svg": 748,
	"./visa.svg": 749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 739;